const keyValuePair = (key, value) => {
  return { key, value }
}

export const findTypeValueByKey = (arr, key) => {
  const item = arr.find((item) => item.key === key)
  return item ? item.value : ""
}

export const deliveryTypes = [
  keyValuePair("WITH_RECEIPT", "請隨貨開立發票"),
  keyValuePair("WITHOUT_RECEIPT", "貨品先出，發票等通知開立")
]

export const maintainServiceStatusTypes = [
  keyValuePair("PROCESSING", "未指派"),
  keyValuePair("ASSIGNED", "已指派人員"),
  keyValuePair("SUCCESS", "已結案")
]

export const maintainServiceStatusTypesClass = [
  keyValuePair("PROCESSING", "warning"),
  keyValuePair("ASSIGNED", "info"),
  keyValuePair("SUCCESS", "success")
]

export const orderStatusTypes = [
  keyValuePair("DRAFT", "草稿"),
  keyValuePair("PROCESSING", "處理中"),
  keyValuePair("SUBMITTED", "已送出(處理中)"),
  keyValuePair("CONFIRMED", "已出貨"),
  keyValuePair("SUCCESS", "訂單完成"),
  keyValuePair("CANCEL", "已取消")
]
export const deviceTypes = [
  keyValuePair("GAS_CHROMATOGRAPHY", "氣象層析"),
  keyValuePair("LIQUID_CHROMATOGRAPHY", "液相層析"),
  keyValuePair("SPECTRUM", "光譜"),
  keyValuePair("OTHER", "其他")
]
export const maintainHistoryTypes = [
  keyValuePair("GETECH", "內部"),
  keyValuePair("COMPANY", "客戶")
]
export const announcementTypes = [
  keyValuePair("AD", "廣告"),
  keyValuePair("BUSINESS", "商品資訊"),
  keyValuePair("CONTRACT", "合約訊息")
]
export const areaTypes = [
  keyValuePair("ALL", "全區"),
  keyValuePair("NORTHERN", "北區"),
  keyValuePair("CENTRAL", "中區"),
  keyValuePair("SOUTHERN", "南區"),
  keyValuePair("EASTERN", "東區"),
  keyValuePair("SURROUNDING", "外島區")
]
export const roleTypes = [
  keyValuePair("SALES_ASSISTANT", "業務助理"),
  keyValuePair("SUPERVISOR", "業務主管"),
  keyValuePair("ENGINEER", "工程師"),
  keyValuePair("CUSTOMER", "一般使用者"),
  keyValuePair("CUSTOMER_PURCHASER", "採購權限客戶")
]
